import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import * as CheckoutActions from '@modules/checkout/CheckoutActions';
import {
    validateFields,
    FormErrors
} from '@components/Forms/partials/FormErrors';
import TextBox from '@components/Forms/partials/TextBox';
import materializeInput from '@components/Fn/materializeInput';
import { PostData } from '../fetchData';

const validation = {
    otp: {
        input_type: 'number',
        required: 1
    },
    password: {
        input_type: 'password',
        required: 1
    }
};

const SetPasswordComponent = ({ checkout, email }) => {
    const [formErrors, setFormErrors] = React.useState({});
    const [loginError, setLoginError] = React.useState('');
    const [submitForm, setFormSubmit] = React.useState(true);

    const ENV_WEB_URL = useSelector(state => state.initState.WEB_URL);

    const dispatch = useDispatch();

    React.useEffect(() => materializeInput(), []);

    const postURL = (url, postData) => {
        setFormSubmit(false);
        PostData(ENV_WEB_URL + url, postData).then(result => {
            const responseJson = result;
            if (responseJson.code === 'success') {
                window.user_details = window.btoa(
                    JSON.stringify(responseJson.profileData)
                );
                if (Storage) {
                    sessionStorage.setItem(
                        'login_details',
                        JSON.stringify(responseJson.profileData)
                    );
                }
                if (
                    checkout === 1 &&
                    (!responseJson.data.address || !responseJson.data.city)
                ) {
                    dispatch(
                        CheckoutActions.uProfile(responseJson.profileData)
                    );
                }

                dispatch(CheckoutActions.profile(responseJson.profileData));
            } else {
                setLoginError(responseJson.errors);
                setFormSubmit(false);
            }
        });
    };

    const handleChange = event => {
        const obj = {
            name: event.target.name,
            value: event.target.value
        };

        validation[obj.name].value = obj.value;

        setLoginError('');
        setFormErrors({});
    };

    const handleSubmit = event => {
        event.preventDefault();

        setLoginError('');
        setFormErrors({});

        const validator = validateFields(validation);
        if (validator.isValid) {
            // Form submitted
            const url = '/reset-password';
            const postData = {
                otp: event.target.otp.value,
                email: event.target.email.value,
                password: event.target.password.value,
                checkout
            };
            postURL(url, postData);
        } else if (validator.errors) {
            setFormErrors(validator.errors);
        }
    };

    return (
        <div className={`block bg ${checkout ? ' full-height' : ''}`}>
            <div className="header">
                <h5 className="text-center">Enter OTP and Password to Login</h5>
                <div className="text-center">
                    OTP has been sent to your Email ID
                </div>
            </div>
            <div className="content">
                <form noValidate onSubmit={handleSubmit} className="form">
                    <div className="form-group form-group-material">
                        <label htmlFor="email-input">
                            Please enter your email id
                        </label>
                        <TextBox
                            id="email-input"
                            className="form-control"
                            readOnly={1}
                            name="email"
                            value={email}
                            onChange={handleChange}
                            type="email"
                            placeHolder="Email ID"
                        />
                    </div>
                    <div className="form-group form-group-material">
                        <label htmlFor="otp-input">One Time Password</label>
                        <TextBox
                            id="otp-input"
                            className="form-control"
                            name="otp"
                            type="text"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group form-group-material">
                        <label htmlFor="password-input">
                            Enter New Password
                        </label>
                        <TextBox
                            id="password-input"
                            className="form-control"
                            name="password"
                            type="password"
                            onChange={handleChange}
                        />
                    </div>
                    <div className={`error${loginError ? ' show' : ''}`}>
                        <small>{loginError}</small>
                    </div>
                    <FormErrors formErrors={formErrors} />
                    <div className="form-group text-center">
                        <button
                            disabled={!submitForm}
                            className="btn btn-warning"
                            type="submit"
                        >
                            Sign In
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SetPasswordComponent;

SetPasswordComponent.propTypes = {
    checkout: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired
};
